import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=daa622c6&scoped=true&"
import script from "./LayoutError.vue?vue&type=script&lang=js&"
export * from "./LayoutError.vue?vue&type=script&lang=js&"
import style0 from "./LayoutError.vue?vue&type=style&index=0&id=daa622c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa622c6",
  null
  
)

export default component.exports